export const heroContent = {
  headline: 'Aprovisionamiento Naval de Clase Mundial',
  subheadline:
    'Desde 1975, operamos 24/7 en los 13 puertos estratégicos de México. Suministro integral, entrega puntual y logística sin fricción para flotas internacionales.',
  ctaPrimary: 'Cotizar Ahora',
  ctaSecondary: 'Ver Servicios',
  trustPillars: [
    {
      label: 'Años de experiencia',
      value: '50+',
      description: 'Desde 1975 en el aprovisionamiento naval',
    },
    {
      label: 'Puertos de cobertura',
      value: '13',
      description: 'Del Pacífico al Golfo de México',
    },
    {
      label: 'Disponibilidad operativa',
      value: '24/7',
      description: 'Respuesta inmediata en cualquier horario',
    },
  ],
  portCards: [
    { name: 'Manzanillo', region: 'Pacífico', color: 'green' },
    { name: 'Salina Cruz', region: 'Pacífico', color: 'teal' },
    { name: 'Lázaro Cárdenas', region: 'Pacífico', color: 'blue' },
    { name: 'Altamira', region: 'Golfo', color: 'indigo' },
    { name: 'Tampico', region: 'Golfo', color: 'violet' },
    { name: 'Tuxpan', region: 'Golfo', color: 'purple' },
    { name: 'Veracruz', region: 'Golfo', color: 'pink' },
    { name: 'Coatzacoalcos', region: 'Golfo', color: 'rose', isHeadquarter: true },
    { name: 'Pajaritos', region: 'Golfo', color: 'orange' },
    { name: 'Dos Bocas', region: 'Golfo', color: 'amber' },
    { name: 'Cd. del Carmen', region: 'Golfo', color: 'yellow' },
    { name: 'Progreso', region: 'Golfo', color: 'lime' },
  ],
  portOverlay: 'Cobertura Nacional en los Principales Puertos de México',
  scrollCue: 'Descubre nuestras soluciones',
};